import styled from '@emotion/styled/macro';

// eslint-disable-next-line import/prefer-default-export
export const FadeAnimation = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 100;

    &.fade-appear {
        opacity: 1;
        z-index: 5;
    }

    &.fade-exit {
        opacity: 1;
    }

    &.fade-exit.fade-exit-active {
        opacity: 0;
        transition: opacity 500ms ease-in-out;
        -webkit-transition: opacity 500ms ease-in-out;
        -moz-transition: opacity 500ms ease-in-out;
        -ms-transition: opacity 500ms ease-in-out;
        -o-transition: opacity 500ms ease-in-out;
    }

    &.fade-exit-done {
        opacity: 0;
    }
`;
